module.exports = __webpack_public_path__ + "img/1693448862881-9c9c694e-4927-4e9e-9b23-843b1bdee6d1.jpeg.f5579b38.webp";